module.exports = __webpack_public_path__ + "static/media/Vector.85f1428f.svg";